import { Card } from "@/components/ui/card";
import { BranchesPanel } from "@/pages/_BranchesPanel";

export default function BranchesPage() {
    return (
        <div className="space-y-6 animate-fade-in" data-testid="branches-page">
            <header>
                <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">Branches</h1>
                <p className="mt-1 text-sm text-zinc-500">
                    Manage every workshop location under your tenant. Each branch keeps its own invoice
                    counter and GST profile.
                </p>
            </header>
            <BranchesPanel />
        </div>
    );
}
